// PLUGINS IMPORTS //
import React, { useState } from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"
import { truncateString } from "Content/Shared/Helpers/Functions/Utils"

// EXTRA IMPORTS //
import { Themes, iPhoneResolution } from "Content/Shared/Styles/Theme"
import { WorkExperienceType } from "../Data"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  item: WorkExperienceType

  isLast: boolean
  nextExist: boolean
}

const BlockItem: React.FC<PropsType> = (props) => {
  const [isFullText, setIsFullText] = useState<boolean>(false)
  const isMobile = Number(window.innerWidth.toString()) <= iPhoneResolution

  return (
    <Wrapper>
      <LeftWrap>
        <div id={"title"}>{props.item.title}</div>
        <h5 id={"date"}> {props.item.date}</h5>
      </LeftWrap>
      <LineWrap>
        <ItemPoint>
          <i className={"fas fa-briefcase"} />
        </ItemPoint>
        <ItemLine hideLine={!props.nextExist} />
      </LineWrap>
      <ContentWrapper>
        <span id={"company-title"}>{props.item.company}</span>
        <span id={"location"}>{props.item.location}</span>
        <div id={"description"}>
          {isMobile && !isFullText
            ? `${truncateString(props.item.description, 11)}...`
            : props.item.description}
          {isMobile && (
            <span onClick={() => setIsFullText((prev) => !prev)}>
              {isFullText ? "Hide" : "See more"}
            </span>
          )}
        </div>
      </ContentWrapper>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
`

const LeftWrap = styled.div`
  text-align: right;
  color: silver;
  flex: 1;

  @media (max-width: ${iPhoneResolution}px) {
    flex: 3;
  }

  #title {
    font-weight: bold;
    font-size: 16.5px;
    color: #e6e6e6;

    @media (max-width: ${iPhoneResolution}px) {
      font-size: 12px;
    }
  }

  #date {
    margin-top: 7px;
  }
`

const ContentWrapper = styled.div`
  flex: 3.3;

  #company-title {
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 1.1em;
    letter-spacing: 1.4px;
    color: ${Themes.colors.primary};
  }

  #location {
    font-size: 0.85em;
  }

  #description {
    margin-top: 10px;
    font-size: 1em;

    span {
      font-size: 0.8em;
      margin: 2px 0px 0px 5px;
      color: ${Themes.colors.primary};
      cursor: pointer;
    }
  }
`

const HORIZONTAL_MARGIN = 45
const LineWrap = styled.div`
  margin-left: ${HORIZONTAL_MARGIN - 10}px;
  margin-right: ${HORIZONTAL_MARGIN + 10}px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-left: ${HORIZONTAL_MARGIN - 35}px;
    margin-right: ${HORIZONTAL_MARGIN - 15}px;
  }
`

const POINT_SIZE = 40
const ItemPoint = styled.div`
  background-color: white;
  height: ${POINT_SIZE}px;
  width: ${POINT_SIZE}px;

  @media (max-width: ${iPhoneResolution}px) {
    height: ${POINT_SIZE - 15}px;
    width: ${POINT_SIZE - 15}px;
    margin-left: 8px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  position: absolute;

  i {
    color: black;
  }
`

const ItemLine = styled.div`
  width: 1px;
  position: aboslute;
  background-color: gray;
  margin-left: ${POINT_SIZE / 2}px;
  z-index: -1;
  opacity: ${(props: { hideLine: boolean }) => (props.hideLine ? 0 : 1)};
  height: 131%;
`

export default React.memo(BlockItem, memoComparison)
